import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/shared/lib/tailwind-merge';

type BaseToggleProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    size?: 'default' | 'large';
};

const BaseToggle = React.forwardRef<
    React.ElementRef<typeof SwitchPrimitives.Root>,
    BaseToggleProps
>(({ className, size = 'default', ...props }, ref) => {
    const sizeClasses = size === 'large' ? 'h-[24px] w-[44px]' : 'h-[20px] w-[36px]';
    const thumbSizeClasses =
        size === 'large'
            ? 'h-[20px] w-[20px] data-[state=checked]:translate-x-5'
            : 'h-[16px] w-[16px] data-[state=checked]:translate-x-4';

    return (
        <SwitchPrimitives.Root
            className={cn(
                'peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-4 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2990ff] focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#000000] data-[state=unchecked]:bg-fourth hover:data-[state=unchecked]:bg-[#e6e6e6] disabled:data-[state=checked]:bg-fourth disabled:data-[state=unchecked]:bg-fourth mt-1',
                sizeClasses,
                className,
            )}
            {...props}
            ref={ref}
        >
            <SwitchPrimitives.Thumb
                className={cn(
                    'pointer-events-none block rounded-full shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0 bg-white disabled:bg-[#D9D9D9] disabled:shadow-none',
                    thumbSizeClasses,
                )}
            />
        </SwitchPrimitives.Root>
    );
});

BaseToggle.displayName = SwitchPrimitives.Root.displayName;

export { BaseToggle };
